import {
  Container,
  Heading,
} from "./styles";
import ArticleQuote from "./ArticleQuote";
import ArticleVideo from "./ArticleVideo";
import ArticleEvent from "./ArticleEvent";
import { PropsWithChildren } from "react";
import SimpleRichText from "@/components/SimpleRichText";

export type ArticleProps = PropsWithChildren<{
  heading: string;
  body: Record<string, any>;
}>;

const Article: React.FC<ArticleProps> = (props) => {
  const { heading, body, children } = props;
  return (
    <Container>
      <Heading as="h1">{heading}</Heading>
      <SimpleRichText  body={body}  types={{
        articleQuote: ArticleQuote,
        articleVideo: ArticleVideo,
        articleEvent: ArticleEvent,
      }} />
      {children}
    </Container>
  );
};

export default Article;
